module.exports = __webpack_public_path__ + "img/welcome_interview.e9736e6.svg";